<template>
  <div class="progress-bar">
    <ul class="progress-bar__bar">
      <li
        v-for="(step, index) in steps"
        :key="`step-${index}`"
        :class="{
          active: value >= index,
          current: value === index,
        }"
        class="flex h-12 items-center"
      >
        <a
          :class="{ 'cursor-default': disablePre && index < value }"
          aria-current="page"
          class="hover:text-black text-black"
          href="#"
          @click.prevent="onClick(index)"
        >
          <i class="icon-circle-check mr-2 text-base" />
          <span>{{ step.name }}</span>
        </a>
      </li>
    </ul>
    <p class="progress-bar__description">{{ stepDescription }}</p>
  </div>
</template>

<script>
import ProgressBar from './ProgressBar';

export default ProgressBar;
</script>

<style lang="scss" scoped>
@import './ProgressBar';
</style>
